<template>
    <div class="real-name-box">
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8">
                    <el-input placeholder="请输入内容" v-model="params.queryValue" class="input-with-select" size="small">
                        <el-select v-model="params.queryKey" slot="prepend" placeholder="请选择">
                            <el-option label="用户ID" :value="1"></el-option>
                            <el-option label="用户名" :value="2"></el-option>
							<el-option label="手机号" :value="3"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button v-if="$utils.have('/userPunish/search')"  type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                </el-col>
            </el-row>
        </div>
        <div v-if="editData" class="page-btns-box">
            <el-button size="small" type="warning" v-if="editData.slienceStatus == 1 " @click="edit(1)">禁言</el-button>
            <el-button size="small" type="warning" v-if="editData.slienceStatus == 0 " @click="openSilent()" :loading="btnLoading">恢复禁言</el-button>
            <el-button size="small" type="danger"  v-if="editData.status == 1 " @click="edit(3)">注销</el-button>
			<el-button size="small" type="warning" v-if="editData.status == 0 " @click="openLogout()" :loading="btnLoading">恢复注销</el-button>
			<el-button size="small" type="danger"  v-if="editData.scalperMark == 1 " @click="edit(5)">标记为黄牛</el-button>
			<el-button size="small" type="warning" v-if="editData.scalperMark == 0 " @click="openScalper()" :loading="btnLoading">取消黄牛标记</el-button>
        </div>
		<div class="page-list-box">
            <el-table
                :data="dataList"		        
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column label="身份">
                    <template slot-scope="scope">
                        {{scope.row.userType && userTypeMap.get(scope.row.userType)}}
                    </template>
                </el-table-column>
                <el-table-column label="用户ID" prop="id"></el-table-column>
                <el-table-column label="用户名" prop="name"></el-table-column>
                <el-table-column label="注册时间" prop="registTime"></el-table-column>
                <el-table-column label="支付订单数" prop="payOrderNum"></el-table-column>		       
            </el-table>
		</div>
		
        <div v-if="editData" class="page-list-box">
            <el-table
                :data="punishes"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column label="处罚时间" prop="createTime"></el-table-column>
                <el-table-column label="处罚类型">
                    <template slot-scope="scope">
                        {{scope.row.type != undefined && punishType.get(scope.row.type)}}
                    </template>
                </el-table-column>
                <el-table-column label="处罚力度">
					<template slot-scope="scope">
					    {{scope.row.day == 0 ? '永久' :scope.row.day + '天'}}
					</template>					
				</el-table-column>
                <el-table-column label="备注" prop="desc"></el-table-column>
                <el-table-column label="恢复时间" prop="endTime"></el-table-column>
                <el-table-column label="处罚人" prop="createUserName"></el-table-column>
                <el-table-column label=" 恢复人" prop="modifyUserName"></el-table-column>
            </el-table>
        </div>
       <Silent v-if="editData" :punishVisible.sync="punishVisible" :editData="editData" :opType="opType" @onUpdate="getDataList"/>	   
    </div>
</template>
<script>
import Silent from './components/silent';

const defaultData = {
    queryKey: 1,
    queryValue: '' 
}

export default {
    data() {
        return {
            dataList: [],
			punishes:null,
			editData: null,
            params: {...defaultData},
            listLoading: false,
			punishVisible: false,			
			opType:1,
			id: this.$route.query.id || '',
            btnLoading: false,
			scalperMark:''
        };
    },
    components: {
       Silent
    },
    computed: {
        punishType(){
            return new Map([
                [1, '禁言'],
                [2, '注销'],
				[3, '标记黄牛'],
            ])
        },
		userTypeMap(){
            return new Map([
                [1, '乐迷'],
                [2, '艺人'],
                [3, '场地'],
                [5, '厂牌']
            ])
		}
        
    },
    created(){
        if(this.id){
            const data = Object.assign(this.params, {queryValue: this.id});
            this.getDataList(data)
        }
    },
    methods: {
        //获取列表
        getDataList(data = this.params) {
            this.listLoading = true;
            this.$request({
                url: "/userPunish/search",
                method: "POST",
                params: data,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {             
                        
                        this.editData = result;
						this.punishes = result.punishes || [];
						//this.scalperMark = result.scalperMark;
                        this.dataList = [{...result}]
						
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
		//恢复禁言
		openSilent(){			
			this.$confirm('确定要恢复禁言吗?', '提示', {
			    type: 'warning',
			    center: true,
                closeOnClickModal: false
			}).then(() => {
			    this.btnLoading = true;
			    this.$request({
			        url: '/userPunish/setPunish',
			        method: 'POST',
			        data: {
			            id:this.editData.id,
			            opType:2
			        }
			    }).then(res => {
			        const { state, msg } = res.data;
			        if( state == 1 ){
			            this.$message.success('操作成功');
			            this.getDataList();
			        }else{
			            this.$message.error(msg || '请求失败');
			        }
			    }).catch(() => {
			        this.$message.error('请求错误');
			    }).finally(() => {
			        this.btnLoading = false;
			    });
			}).catch(() => {});
			
		},
		//恢复注销
		openLogout(){			
			this.$confirm('确定要恢复注销吗?', '提示', {
			    type: 'warning',
			    center: true,
                closeOnClickModal: false
			}).then(() => {
			    this.btnLoading = true;
			    this.$request({
			        url: '/userPunish/setPunish',
			        method: "POST",
			        data: {
			            id:this.editData.id,
			            opType:4
			        }
			    }).then(res => {
			        const { state, msg } = res.data;
			        if( state == 1 ){
			            this.$message.success('操作成功');
			            this.getDataList();
			        }else{
			            this.$message.error(msg || '请求失败');
			        }
			    }).catch(() => {
			        this.$message.error('请求错误');
			    }).finally(() => {
			        this.btnLoading = false;
			    });
			}).catch(() => {});  
			   
			   
		},
		//取消黄牛标记
		openScalper(){
			this.$confirm('确定取消黄牛标记吗?', '提示', {
			    type: 'warning',
			    center: true,
			    closeOnClickModal: false
			}).then(() => {
			    this.btnLoading = true;
			    this.$request({
			        url: '/userPunish/setPunish',
			        method: "POST",
			        data: {
			            id:this.editData.id,
			            opType:6
			        }
			    }).then(res => {
			        const { state, msg } = res.data;
			        if( state == 1 ){
			            this.$message.success('操作成功');
			            this.getDataList();
			        }else{
			            this.$message.error(msg || '请求失败');
			        }
			    }).catch(() => {
			        this.$message.error('请求错误');
			    }).finally(() => {
			        this.btnLoading = false;
			    });
			}).catch(() => {}); 
		},
        //搜索
        search() {
            if( this.params.queryValue ){
                this.getDataList();
            }else{
                this.$message.warning('请输入查询关键字');
            }
        },
        //重置搜索
        reset() {
            this.params = {...defaultData}
            this.getDataList();
        },
        edit(opType){
            this.punishVisible = true;
            this.opType = opType;
        },
		
    }
};
</script>
